
import { JSX } from "react";

export { makeStyles, tokens, shorthands, useTagPickerFilter } from "@fluentui/react-components";
export type { DrawerProps } from "@fluentui/react-components";
export { default as Avatar } from "./Avatar";
export { default as Accordion } from "./Accordion";
export { default as AccordionItem } from "./Accordion/AccordionItem";
export { default as AccordionHeader } from "./Accordion/AccordionItem/AccordionHeader";
export { default as AccordionPanel } from "./Accordion/AccordionItem/AccordionPanel";
export { default as Drawer } from "./Drawer";
export { default as DrawerBody } from "./Drawer/DrawerBody";
export { default as DrawerFooter } from "./Drawer/DrawerFooter";
export { default as Menu } from "./Menu";
export { default as MenuList } from "./Menu/MenuList";
export { default as MenuItem } from "./Menu/MenuList/MenuItem";
export { default as MenuPopover } from "./Menu/MenuPopover";
export { default as MenuTrigger } from "./Menu/MenuTrigger";
export { default as MessageBar } from "./MessageBar";
export { default as MessageBarBody } from "./MessageBar/MessageBarBody";
export { default as MessageBarActions } from "./MessageBar/MessageBarActions";
export { default as MessageBarTitle } from "./MessageBar/MessageBarBody/MessageBarTitle";
export { default as Popover } from "./Popover";
export { default as PopoverSurface } from "./Popover/PopoverSurface";
export { default as PopoverTrigger } from "./Popover/PopoverTrigger";
export { default as Tooltip } from "./Tooltip";
export { default as Link } from "./Link";
export { default as Breadcrumb } from "./Breadcrumb";
export { default as BreadcrumbItem } from "./Breadcrumb/BreadcrumbItem";
export { default as BreadcrumbButton } from "./Breadcrumb/BreadcrumbItem/BreadcrumbButton";
export { default as BreadcrumbDivider } from "./Breadcrumb/BreadcrumbDivider";
export { default as Text } from "./Text";
export { default as Label } from "./Label";
export { default as TabList } from "./TabList";
export { default as Tab } from "./TabList/Tab";
export { default as TextField } from "./Field/TextField";
export { default as TextAreaField } from "./Field/TextAreaField";
export { default as ComboboxField } from "./Field/ComboboxField";
export { default as DropdownField } from "./Field/DropdownField";
export { default as DropdownSearchField } from "./Field/DropdownSearchField";
export { default as SearchField } from "./Field/SearchField";
export { default as Field } from "./Field";
export { default as Button } from "./Button/Button";
export { default as MenuButton } from "./Button/MenuButton";
export { default as Input } from "./Input";
export { default as SearchBox } from "./SearchBox";
export { default as Skeleton } from "./Skeleton";
export { default as SkeletonItem } from "./Skeleton/SkeletonItem";
export { default as InfoLabel } from "./InfoLabel";
export { default as Checkbox } from "./Checkbox";
export { default as Spinner } from "./Spinner";
export { default as RadioGroup } from "./RadioGroup";
export { default as Radio } from "./RadioGroup/Radio";
export { default as CheckboxGroup } from "./Checkbox/CheckboxGroup";
export { default as Calendar } from "./Calendar";
export { default as Switch } from "./Switch";
export { default as Card } from "./Card";
export { default as CardPreview } from "./Card/CardPreview";
export { default as CardHeader } from "./Card/CardHeader";
export { default as CardFooter } from "./Card/CardFooter";
export { default as BlockItem } from "./BlockItem";
export { default as ColorField } from "./Field/ColorField";
export { default as Toaster } from "./Toast/Toaster";
export { default as Toast } from "./Toast/Toast";
export { default as ToastTitle } from "./Toast/ToastTitle";
export { default as Tag } from "./Tag";
export { default as Dropdown } from "./Dropdown";
export { default as Toolbar } from "./Toolbar";
export { default as ToolbarButton } from "./Toolbar/ToolbarButton";
export { default as ToolbarGroup } from "./Toolbar/ToolbarGroup";
export { default as ToolbarDivider } from "./Toolbar/ToolbarDivider";
export { default as Slider } from "./Slider";
export { default as FieldDatePicker } from "./Field/FieldDatePicker";
export { default as TimePickerField } from "./Field/TimePickerField";
export { default as CounterBadge } from "./CounterBadge";
export { default as ToastBody } from "./Toast/ToastBody";
export { default as Image } from "./Image";
export { default as TagPicker } from "./TagPicker";
export { default as TagPickerControl } from "./TagPicker/TagPickerControl";
export { default as TagPickerGroup } from "./TagPicker/TagPickerGroup";
export { default as TagPickerInput } from "./TagPicker/TagPickerInput";
export { default as TagPickerList } from "./TagPicker/TagPickerList";
export { default as TagPickerOption } from "./TagPicker/TagPickerOption";
export { default as ProgressBar } from "./ProgressBar";
export { default as FluentProvider } from "./FluentProvider";
export { default as Dialog } from "./Dialog";
export { default as DialogTrigger } from "./Dialog/DialogTrigger";
export { default as DialogTitle } from "./Dialog/DialogTitle";
export { default as DialogSurface } from "./Dialog/DialogSurface";
export { default as DialogActions } from "./Dialog/DialogActions";
export { default as DialogBody } from "./Dialog/DialogBody";
export { default as DialogContent } from "./Dialog/DialogContent";
export { default as Divider } from "./Divider";
export { default as Badge } from "./Badge";

export enum ETheme {
  Dark = "dark",
  Light = "light",
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IOption<T = any> {
  value: string;
  text: string;
  icon?: JSX.Element;
  disabled?: boolean;
  extraData?: T;
}

export enum EAlignment {
  TOP = "top",
  BOTTOM = "bottom",
  START = "start",
  END = "end",
  CENTER = "center",
}

export enum EPosition {
  ABOVE = "above",
  BELOW = "below",
  BEFORE = "before",
  AFTER = "after",
}
